export default {
  title: '{{company}} heeft je afhaaltijd gewijzigd',
  title_on_site: '{{company}} heeft aangepast wanneer je bestelling wordt geserveerd',
  new_time_label: 'Nieuwe tijd',
};
